import { createSelector } from 'reselect';
import { RootState } from '../root.reducers';
import { SecurityInfo } from './securityInfo.types';

export const getSecurityInfos = (state: RootState): SecurityInfo[] => state.securityInfo.entities;
export const getSecurityInfo = (state: RootState): SecurityInfo | null => state.securityInfo.single;
export const getSecurityInfoCreatedId = (state: RootState): string | null => state.securityInfo.createdId;

export const getSecurityInfosFilteredByTlsAndDtls = createSelector(
  [getSecurityInfos],
  (securityInfos) => securityInfos?.filter(({ intfType }) => intfType === 'TLS' || intfType === 'DTLS') ?? [],
);

export const isSecurityInfoCreatePopupOpen = (state: RootState): boolean => {
  return state.securityInfo.ui.isCreatePopupOpen;
};

export const isSecurityInfoLoading = (state: RootState): boolean => state.securityInfo.ui.isLoading;
